/**
 * Event type helpers (mirrors server/src/config/eventTypes.js)
 *
 * Two distinct questions get asked about an event, and they are NOT the same:
 *
 *   isCumulativeRound() — do this event's rounds sum to a single event total?
 *                         True for TML and for 'open' (guest) events. Drives the
 *                         cumulative/round-points columns and the winner label.
 *
 *   hasBowl()           — is this a TML-branded event with a Bowl and formal
 *                         playoff resolution? TML only. Guest events must not
 *                         show Society furniture.
 */
export const CUMULATIVE_EVENT_TYPES = ['tml', 'open'];

export function isCumulativeEvent(eventType) {
  return CUMULATIVE_EVENT_TYPES.includes(eventType);
}

/** A round whose points accumulate into an event total. */
export function isCumulativeRound(round) {
  return isCumulativeEvent(round?.event_type) && round?.round_type === 'championship';
}

/** The Bowl and playoff resolution are TML brand concepts. */
export function hasBowl(eventType) {
  return eventType === 'tml';
}

/** Label for the outright winner of a completed cumulative event. */
export function championLabel(eventType) {
  return eventType === 'tml' ? 'Champion Golfer of the Year' : 'Winner';
}
